const INS_AUTO_BASE_ROUTES = {
    EN: '/insurance/car-quotes',
    FR: '/assurance/soumission-assurance-auto',
};

const INS_HOME_BASE_ROUTES = {
    EN: '/insurance/home-quotes',
    FR: '/assurance/soumission-assurance-habitation',
};

const INS_LIFE_BASE_ROUTES = {
    EN: '/insurance/life-quotes',
    FR: '/assurance/soumission-de-la-vie',
};

export {
    INS_AUTO_BASE_ROUTES,
    INS_HOME_BASE_ROUTES,
    INS_LIFE_BASE_ROUTES,
};
